<template>
    <div class="stepThree">
        <headers></headers>
        <div class="content">
            <steps :step-num="2"></steps>
            <div class="stepThree-form">
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
                    <FormItem prop="password">
                        <Input v-model="formValidate.password" type="password" password placeholder="请输入新密码" />
                    </FormItem>
                    <FormItem prop="passwords">
                        <Input v-model="formValidate.passwords" type="password" password placeholder="请确认新密码" />
                    </FormItem>
                    <FormItem>
                        <Button type="primary" long @click="handleSubmit('formValidate')">下一步</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import headers from '../../components/pc/header.vue'
    import steps from '../../components/pc/steps.vue'
    import * as utils from '../../utils'
    export default {
        name: "stepThree",
        components: {
            headers,
            steps
        },
        data() {
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认新密码'));
                } else if (value !== this.formValidate.password) {
                    callback(new Error('确认密码不一致'));
                } else {
                    callback();
                }
            };
            return {
                formValidate: {
                    password: '',
                    passwords: '',
                },
                ruleValidate: {
                    password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                    passwords: [{ validator: validatePassCheck, trigger: 'blur' }],
                },
            }
        },
        created() {
            if(!this.userInfos.sessionId) {
                this.$router.push({path: '/stepOne',query: {service: this.$route.query.service}})
            }
        },
        computed: {
            ...mapState({
                userInfos: state=>state.userInfo,
                cardIds: state=>state.cardId,
            })
        },
        methods: {
            changePwd() {
                utils.Post('https://id.scuec.edu.cn/activateAccount/finishActivate',{
                    sessionId: this.userInfos.sessionId,
                    userAccount: this.userInfos.userAccount,
                    userPwd: this.formValidate.password,
                }).then(res => {
                    this.$router.push({path: '/stepFour',query: {service: this.$route.query.service}})
                })
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        utils.Post('https://id.scuec.edu.cn/activateAccount/pwdComplexity',{
                            pwd: this.formValidate.password,
                        }).then(res => {
                            if(res.data.errCode == '0') {
                                this.changePwd()
                            } else {
                                this.$Message.warning(res.data.errMsg)
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .content{
        width: 800px;
        margin: 50px auto 0;
    }
    .stepThree-form{
        width: 360px;
        margin: 50px auto 0;
    }
</style>



// WEBPACK FOOTER //
// stepThree.vue?59fe69d0